import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TournamentTeamService } from '@core/services/tournament-team.service';
import {
  componentDestroyed, GameHockeyPosition, TeamUserRole,
  TournamentDisqualification,
  TournamentTeamUser,
  UntilDestroy
} from '@mtgame/core';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GameUserLimitationTypes } from '@mtgame/core/models/game-user-limitation';
import { getLeaguePlayerRoute } from '@config/routes';
import { DOCUMENT_FIELD_IDS } from '@utils/hardcode';

interface DisqualifiedUser {
  user: TournamentTeamUser;
  disqualification: TournamentDisqualification;
  limitations: GameUserLimitationTypes;
  haveDocuments: boolean;
  haveNoPersonalInfo: boolean;
}

@UntilDestroy
@Component({
  selector: 'mtg-tournament-team-disqualifications',
  templateUrl: './tournament-team-disqualifications.component.html',
  styleUrls: ['./tournament-team-disqualifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TournamentTeamDisqualificationsComponent implements OnInit, OnDestroy {
  data: DisqualifiedUser[] = [];
  hockeyPositions = GameHockeyPosition;

  constructor(
    private tournamentTeamService: TournamentTeamService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    combineLatest([
      this.tournamentTeamService.users$.pipe(takeUntil(componentDestroyed(this))),
      this.tournamentTeamService.usersLimitation$.pipe(takeUntil(componentDestroyed(this))),
    ]).subscribe(([users, limitations]) => {
      const limitationsMapping = limitations
        .filter(item => item.limitations &&
          (item.limitations.minGoalkeeperUserTime || item.limitations.minGoalkeeperUserGamesCount ||
            item.limitations.minUserGamesCount || item.limitations.minUserTime || item.limitations.manual))
        .reduce((acc, item) => ({
        ...acc,
        [item.tournamentTeamUserId]: item.limitations,
      }), {});
      this.data = users
        .filter(item => [
            TeamUserRole.member, TeamUserRole.moderator,
            TeamUserRole.admin, TeamUserRole.captain,
            TeamUserRole.playing_coach, TeamUserRole.assistant
          ].includes(item.teamUser.role)
        )
        .map(item => {
          const limitation = limitationsMapping[item.id];
          const docFieldIds = DOCUMENT_FIELD_IDS;
          const haveDocuments = item.leaguePlayer.fieldValues
            .filter(item => docFieldIds.includes(item.leaguePlayerFieldId)
              && item.leaguePlayerField.getName(item.value) === 'сдал')
            .length === docFieldIds.length;
          const haveNoPersonalInfo = !item.leaguePlayer.photo.path || (!item.leaguePlayer.rating && item.teamUser.user.hockeyProfile.position !== GameHockeyPosition.goaltender);
          // const haveNoPersonalInfo = false;
          return {
            user: item,
            disqualification: item.disqualification,
            conditionalDisqualification: item.conditionalDisqualification,
            limitations: limitation,
            haveDocuments,
            haveNoPersonalInfo,
          };
        })
        .filter(item => item.disqualification.id || item.conditionalDisqualification.id || item.limitations || !item.haveDocuments || item.haveNoPersonalInfo);
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy() {
  }

  getUserRoute(leaguePlayerId: number): string[] {
    return getLeaguePlayerRoute(leaguePlayerId);
  }
}
